export default {

    Line: 'line',

}